const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
import { withRouter } from 'react-router-dom';

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const CardBenefitsBenefitsSection = require('components/cards/cardBenefits/cardBenefitsBenefitsSection/cardBenefitsBenefitsSection');
const CardBenefitsTelephonesSection = require('components/cards/cardBenefits/CardBenefitsTelephonesSection/cardBenefitsTelephonesSection');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const InterestsExample = require('components/interestsExample/interestsExample');

// @utilities
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions
const cardBenefitsActions = require('actions/cardBenefits');
const collectivesActions = require('actions/collectives');

// @constants
const TRANSLATION_PREFIX = 'cardBenefitsView-';
const { DIAMOND_PACK_PRODUCT_ALIAS, PREMIUM_PACK_PRODUCT_ALIAS, PRODUCT_HIRED_DETAILS_COMPONENT_ID } = require('constants/hiringProductInformation');

class CardBenefitsView extends React.Component {
  constructor(props) {
    super(props);

    this.buildContent = this.buildContent.bind(this);
  }

  componentDidMount() {
        const { match: { params: { cardId } }, immProfile, immCards, getCollectiveInfo, collectivosEnabled } = this.props;
    const immCard = cardId && immCards.getIn(['byId', cardId]);
    let cType = this.getCardType(immCard);
    this.props.setBenefitsList(cType);
    if (immProfile.get('isCollective') && cardId && collectivosEnabled) {
      //get the product details for hired selected card
      const immCard = immCards.getIn(['byId', cardId]);
      const immProduct = immCard.get('product');
      const product = {
        type: immProduct.get('type'),
        subType: immProduct.get('subtype'),
                standard: immProduct.get('standard')
      };
      getCollectiveInfo([product], PRODUCT_HIRED_DETAILS_COMPONENT_ID, true);
    }
  }
  getCardType(immCard) {
        const { match: { params: { cardType } } } = this.props;
    let cType;
    if (immCard.get('isMetallic')) {
      cType = 'r42Metalic';
        }
        else if (immCard.get('isR42MasterCard')) {
      cType = 'r42Master';
        }
        else if (immCard.get('isR42BetaalPasCard')) {
      cType = 'r42BetaalPas';
        }
        else {
      cType = cardType;
    }
    return cType;
  }
  getCollectiveAlias(cardType) {
    if (cardType) {
      const collectiveAlias = {
                'premium': PREMIUM_PACK_PRODUCT_ALIAS,
                'diamond': DIAMOND_PACK_PRODUCT_ALIAS,
            }
      return collectiveAlias[cardType];
    }
  }

  buildBreadcrumb() {
    const {
      immCards,
      match: {
                params: {
                    cardId,
                },
      },
    } = this.props;

    let breadcrumb = [
      {
        text: formatText('breadcrumb-cards'),
        url: '/myprofile/cards',
            }
    ];
    let secondText = 'breadcrumb-breadcrumb_cardBenefitsR42';

    if (this.isDiamond()) {
      secondText = 'breadcrumb-cardBenefitsDiamond';
    } else if (this.isPremium()) {
      secondText = 'breadcrumb-cardBenefitsPremium';
    }

    if (!!cardId) {
      const immCard = immCards.getIn(['byId', cardId]);
      const cardAlias = immCard.getIn(['alias', 'current']);

            breadcrumb.push(
                {
        text: cardAlias,
        url: `/myprofile/cards/${cardId}/movements`,
                }
            );
    }

        breadcrumb.push(
            {
      text: formatText(secondText),
            }
        );

    return breadcrumb;
  }

  buildContent() {
        const { immCardBenefits, immProfile, immCards, match: { params: { cardType, cardId } } } = this.props;
    const isDiamond = this.isDiamond();
    const isPremium = this.isPremium();
    const immCard = cardId && immCards.getIn(['byId', cardId]);
        const cType = this.getCardType(immCard)
    let benefitsList = immCardBenefits.getIn(['benefitsList', 'benefits']);
    let telephonesList = immCardBenefits.getIn(['benefitsList', 'telephones']);
        let disclaimerText = immCard.get('isR42MasterCard') ? 'r42MasterDisclaimerText' : immCard.get('isMetallic') ? 'r42MetallicDisclaimerText' : immCard.get('isR42BetaalPasCard') ? 'r42BetaalPasDisclaimerText' : '';
    if (immProfile.get('isCollective')) {
      benefitsList = immCardBenefits.getIn(['benefitsList', 'collectivosBenefits']);
    }

    if (cType === 'r42') {
      benefitsList = benefitsList.slice(0, 4);

      if (immCard.get('type') === 'debit' && !!benefitsList.get(1)) {
        const currentBenefit = benefitsList.get(1);
        const newBenefit = currentBenefit.set(
          'text',
          'cardBenefits-cardBenefits_openDebitBenefitsSecond'
        );
        benefitsList = benefitsList.delete(1).insert(1, newBenefit);
      }

      telephonesList = telephonesList.slice(2, 4);
    }

    return (
      <div>
        <div className="col-xs-12 col-md-8">
          <CardBenefitsBenefitsSection
            immBenefits={benefitsList}
            immProfile={immProfile}
            immCard={immCard}
            cardType={cardType}
            collectiveAlias={this.getCollectiveAlias(cardType)}
          />
          <div className="card-benefits-view__telephones-section">
                        <CardBenefitsTelephonesSection immTelephones={telephonesList} isDiamond={isDiamond} isPremium={isPremium} immCard={immCard} />
          </div>
                    {disclaimerText &&
            <InterestsExample keyText={`cardBenefits-${disclaimerText}`} benefitSection />
                    }
        </div>
        <div className="col-xs-12 col-md-4 grid-view--variable-cell-separation">
                    <CallMeBack pageTitle={formatText('breadcrumb-cards')} hasEntrance={false}/>
        </div>
      </div>
    );
  }

  isDiamond() {
    return this.props.match.params.cardType === 'diamond';
  }

  isPremium() {
    return this.props.match.params.cardType === 'premium';
  }

  render() {
        const { immCardBenefits, match: { params: { cardType } } } = this.props;
    const validTypes = ['diamond', 'premium', 'r42'];
    const mappingBreadcrumb = this.buildBreadcrumb();
    let content = <LoadingSection />;

    if (validTypes.includes(cardType) && immCardBenefits.get('benefitsList').count()) {
      content = this.buildContent();
    }

    const titleTransKey = cardType + 'Title';

    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <OKCover size="medium" section="cards" customClass="col-xs-12">
              <OKHeaderSubPage
                breadcrumbConfig={mappingBreadcrumb}
                finalTitle={getFinalTitle(`${TRANSLATION_PREFIX}${titleTransKey}`)}
              />
            </OKCover>
          </div>
        </div>
        <div className="grid-view__body">
          <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
          </div>
        </div>
      </div>
    );
  }
}

CardBenefitsView.propTypes = {
  collectivosEnabled: PropTypes.bool.isRequired,
  immCardBenefits: PropTypes.object,
  immCards: PropTypes.object,
  immProfile: PropTypes.object,
  match: PropTypes.object,
  setBenefitsList: PropTypes.func,
  getCollectiveInfo: PropTypes.func.isRequired,
};

module.exports.constructor = CardBenefitsView;
module.exports.CardBenefitsView = withRouter(connect(state => ({
      collectivosEnabled: state.flagBasedFeatures.get('collectivos-enabled'),
      immCardBenefits: state.cardBenefits,
      immCards: state.cards,
      immProfile: state.profile,
}), {
      setBenefitsList: cardBenefitsActions.setCardBenefitsList,
    getCollectiveInfo: collectivesActions.getCollectiveInfo
})(CardBenefitsView));
